import React, {Fragment} from "react";
import StepButton from "components/Step/StepButton";
import StepQuestion from "components/Step/StepQuestion";
import {getDocumentNameByIdType} from "domain/Customer/IdTypeEnum";
import {RegistrationElements} from "domain/Registerv2/RegistrationElements";
import {Input} from "reactstrap";
import ToastHelper from "utils/ToastHelper";
import FileUtil from "domain/Util/FileUtil";
import StepLoadingComponent from "components/Step/StepLoadingComponent";
import S3DocumentUploadService from "services/S3DocumentUploadService";

export default class DocumentUploadStep extends React.Component {

    static ACCEPT_IMAGES = "image/*";
    static ACCEPT_IMAGES_PDF = "image/*, .pdf";

    constructor(props, context) {
        super(props, context);
        this.state = {
            fileName: "",
            maxSize: 5242880,
            selectedDocument: this.props.selectedDocument,
            selectedDocumentUploaded: this.isValidMetaDataId(this.props[this.props.registrationElement]),
            uploading: false
        };
    }

    isValidMetaDataId(metaDataId) {
        if (isNaN(metaDataId)) {
            return false;
        }
        let x = parseFloat(metaDataId);
        return (x | 0) === x;
    }

    handleChange(event) {
        if (event.target.files[0].size > this.state.maxSize) {
            ToastHelper.error("Only files less than " + FileUtil.getSizeInMB(this.state.maxSize) + " MB allowed.");
        } else {
            let selectedDocument = {
                fileName: event.target.value,
                fileUpload: event.target.files[0],
                fileSize: event.target.files[0].size,
                filePreview: URL.createObjectURL(event.target.files[0]),
                showFilePreviewText: false,
            };
            this.setState({selectedDocument: selectedDocument, selectedDocumentUploaded: false});
            this.fireDocumentSelected(selectedDocument);
        }
    }

    onNextClick() {
        this.setState({
            uploading: true
        });

        if (!this.state.selectedDocumentUploaded) {
            this.uploadFile(this.state.selectedDocument);
        } else {
            this.onUploadSuccessful(this.props[this.props.registrationElement]);
        }
    }

    onUploadSuccessful(metaDataId) {
        if (this.props.onNextClick) {
            this.props.onNextClick(metaDataId);
        }
    }

    uploadFile(file) {

        let fileType = FileUtil.getExtensionOfFile(file.fileName);
        let mimeType = FileUtil.getMimeType(fileType);

        let self = this;
        S3DocumentUploadService.saveAndGetPresignedUrl(this.props.s3DocumentType, fileType).then(response => {
            if (response.presignedUrl === undefined) {
                ToastHelper.error("Failed to retrieve upload url.");
                return;
            }

            const xhr = new XMLHttpRequest();
            xhr.open('PUT', response.presignedUrl);
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        self.onUploadSuccessful(response.id);
                    } else {
                        this.setState({
                            uploading: false
                        });
                        ToastHelper.error("Error uploading image.");
                    }
                }
            };
            xhr.overrideMimeType(mimeType);
            xhr.setRequestHeader('Content-Type', mimeType);
            xhr.send(file.fileUpload);
        });
    }

    fireDocumentSelected(selectedDocument) {
        if (this.props.onDocumentSelected)
            this.props.onDocumentSelected(selectedDocument);
    }

    render() {
        if (this.state.uploading) {
            return <StepLoadingComponent
                message={<Fragment>&nbsp;&nbsp;&nbsp;&nbsp;Uploading...</Fragment>}
            />
        }

        return <Fragment>
            <StepQuestion>
                {this.renderQuestionText()}
            </StepQuestion>
            {this.renderContent()}
        </Fragment>
    }

    renderContent() {

        return <Fragment>
            <div className={"step_document_upload_button"}>

                <StepButton
                    className={"step_button_upload"}
                >
                    {
                        this.state.selectedDocument === undefined
                            ? "Select Document"
                            : "Change Document"
                    }
                </StepButton>
                <div className={"step_document_preview " + (this.state.selectedDocument === undefined ? "blank" : "")}>
                    {this.renderPreview()}
                </div>
                <Input
                    type="file"
                    value={this.state.fileName}
                    onChange={this.handleChange.bind(this)}
                    accept={this.props.accept || DocumentUploadStep.ACCEPT_IMAGES_PDF}
                />
            </div>

            <StepButton
                color={"primary"}
                disabled={this.state.selectedDocument === undefined}
                onClick={this.onNextClick.bind(this)}
            >
                {this.state.selectedDocumentUploaded ? "Next" : "Upload"}
            </StepButton>
            <StepButton
                color={"secondary"}
                onClick={this.props.onBackClick}
            >
                {"Back"}
            </StepButton>
        </Fragment>
    }

    renderPreview() {
        if (this.state.selectedDocument === undefined) {
            return this.renderPlaceHolder();
        }
        if (this.state.selectedDocument.fileName.indexOf(".pdf") > 0)
            return <img src={"images/pdf-icon.png"} alt={"File preview"}/>
        else
            return <img src={this.state.selectedDocument.filePreview} alt={"File preview"}/>

    }

    renderQuestionText() {
        if (this.props.customMessage !== undefined) {
            return this.props.customMessage;
        }
        let idType = this.props[RegistrationElements.ID_TYPE];
        switch (this.props.registrationElement) {
            case RegistrationElements.ID_DOCUMENT:
                return <Fragment>Please upload a <span className={"step_bold"}>clear</span> picture of
                    your {getDocumentNameByIdType(idType)}:</Fragment>
            case RegistrationElements.SELFIE_DOCUMENT:
                return <Fragment>Please upload a picture of <span className={"step_bold"}>yourself</span> holding
                    the {getDocumentNameByIdType(idType)}:</Fragment>
            default:
                return "Please upload your document:";
        }
    }

    renderPlaceHolder() {
        switch (this.props.registrationElement) {
            case RegistrationElements.ID_DOCUMENT:
                return <img
                    className={"ghost_image"}
                    src={"images/cartoon_id.png"}
                    style={{padding: "0px"}}
                    alt={"No file selected."}
                />
            case RegistrationElements.SELFIE_DOCUMENT:
                return <img
                    className={"ghost_image"}
                    src={"images/cartoon_selfie.png"}
                    style={{padding: "10px"}}
                    alt={"No file selected."}
                />
            default:
                return <i className={"fa fa-image"}/>;
        }
    }
}